var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-aside',{staticStyle:{"box-shadow":"2px 0 6px rgb(0 21 41 / 35%)"},attrs:{"width":"220px"}},[_c('common-aside',{staticStyle:{"width":"100%"}})],1),_c('el-container',[_c('el-header',[_c('common-header')],1),_c('common-tag'),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }